import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import NewsItem from './NewsItem'
import { useDefaultComponentTools } from '../../../../../hooks/useDefaultComponentTools'
import { selectFilteredNewsArr} from '../../../../../store/redusers/positions/selectors'

const News = () => {
	const { t } = useDefaultComponentTools()
	const news = useSelector(selectFilteredNewsArr)
	const ref = useRef()
	const { lgUp } = useDefaultComponentTools()
	const [isScrollBar, setIsScrollBar ] = useState(false)
	useEffect(() => {
		if(!news?.length) return
		const div = ref.current
		setIsScrollBar(div.scrollHeight !== div.offsetHeight)
	}, [news])

	return (
		<Box ref={ref} sx={{height: lgUp ? '100%' : '300px', overflow: 'auto'}}>
			{!news?.length ? <Typography sx={{p: '15px'}}>{t('No news yet')}</Typography> : news.map((news, index) =>
				<NewsItem isScrollBar={isScrollBar} key={index} news={news} />
			)}
		</Box>
	)
}

export default News
